import { SensorModelConfiguration } from '../types';

/**
 * Configuration du modèle DRAGINO LHT65
 * Capteur de température et humidité
 */
export const DRAGINO_LHT65: SensorModelConfiguration = {
  brand: 'DRAGINO',
  model: 'LHT65',
  metrics: {
    temperature: {
      type: 'number',
      unit: '°C',
      icon: 'TemperatureIcon',
      color: 'error.main',
      labelRef: 'temperature'
    },
    humidity: {
      type: 'number',
      unit: '%',
      icon: 'HumidityIcon',
      color: 'info.main',
      labelRef: 'humidity'
    }
  }
};
